import { useEffect, useRef, default as React } from 'react';
import ExtractedHTML from './ExtractedHtml';

function slugify(str) {
  return String(str)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
}

function autoID(el) {
  let i = 0;
  el.querySelectorAll('h2,h3,h4,h5,h6').forEach((node) => {
    if (!node.id) {
      node.id = `${1 + i++}-${slugify(node.innerText)}`;
    }
  });
}

function setupEmbeds(el) {
  const fullWidthEmbeds = ['vimeo', 'youtube'];
  if (!window.Paperform) {
    const script = document.createElement('script');
    script.src = 'https://paperform.co/__embed.min.js';
    document.body.appendChild(script);
  }
  el.querySelectorAll('.kg-embed-card').forEach((node) => {
    if (node._setup) {
      return;
    }
    node._setup = 1;
    const iframe = node.querySelector('iframe');
    const src =
      (iframe &&
        (iframe.getAttribute('data-src') || iframe.getAttribute('src'))) ||
      '';
    const isFullWidth = fullWidthEmbeds.find((code) => src.includes(code));
    if (isFullWidth) {
      node.className += ' kg-embed-fullwidth';
    }
  });
  // Enable insta embeds
  if (
    el.querySelector('.instagram-media') ||
    el.querySelector('[data-instgrm-captioned]')
  ) {
    const script = document.createElement('script');
    script.async = true;
    script.src = '//www.instagram.com/embed.js';
    document.body.appendChild(script);
  }

  if (el.querySelector('.embedly-card')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = '//cdn.embedly.com/widgets/platform.js';
    document.body.appendChild(script);
  }
  if (el.querySelector('.tiktok-embed')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.tiktok.com/embed.js';
    document.body.appendChild(script);
  }
  if (el.querySelector('.twitter-tweet')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://platform.twitter.com/widgets.js';
    document.body.appendChild(script);
  }

  if (el.querySelector('.slack-embed')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://platform.twitter.com/widgets.js';
    document.body.appendChild(script);
  }
  // Embed zapier
  if (
    el.querySelector(
      '.zapier-embed,zapier-app-directory,zapier-zap-templates,zapier-full-experience',
    )
  ) {
    // Load JS
    const script = document.createElement('script');
    script.type = 'module';
    script.src =
      'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';
    document.head.appendChild(script);

    // Load CSS
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href =
      'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';
    document.head.appendChild(stylesheet);
  }
}

export function BlogSetup({ content }) {
  const ref = useRef();
  useEffect(() => {
    if (!ref.current) return;
    autoID(ref.current);
    setupEmbeds(ref.current);
  }, []);

  return (
    <div ref={ref}>
      <ExtractedHTML html={content.replace('[TOC]', '')} />
    </div>
  );
}
